var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_12598",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_12598)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50156 0.599976C3.69435 0.599976 0.601562 3.69276 0.601562 7.49998C0.601562 11.3072 3.69435 14.4 7.50156 14.4C11.3088 14.4 14.4016 11.3072 14.4016 7.49998C14.4016 3.69276 11.3088 0.599976 7.50156 0.599976ZM7.50117 1.19995C10.9841 1.19995 13.8012 4.017 13.8012 7.49995C13.8012 10.9829 10.9841 13.8 7.50117 13.8C4.01822 13.8 1.20117 10.9829 1.20117 7.49995C1.20117 4.017 4.01822 1.19995 7.50117 1.19995ZM7.20137 3.90002V7.20002H3.90137V7.80002H7.20137V11.1H7.80137V7.80002H11.1014V7.20002H7.80137V3.90002H7.20137Z",
    fill: "#B6C0CD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundPlus);
export default __webpack_public_path__ + "static/media/roundPlus.821eb062594ab90958bafece0bc2d779.svg";
export { ForwardRef as ReactComponent };